import { render, staticRenderFns } from "./ButtonFavoris.vue?vue&type=template&id=959de078&"
import script from "./ButtonFavoris.vue?vue&type=script&lang=ts&"
export * from "./ButtonFavoris.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports